import { RequestData } from "~utils";

export function isSubReconfirmed(request: RequestData) {
  return Boolean(request.isReconfirmed);
}

export function canSubReconfirm(request: RequestData, reconfirm: boolean) {
  return reconfirm && !isSubReconfirmed(request) && request.action === "ACTION_SUB_CAN_CANCEL";
}

export function showReconfirmAlert(request: RequestData, reconfirm: boolean) {
  return reconfirm && isSubReconfirmed(request);
}
